import React, { useEffect } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import pic1 from "../../../assets/images/WhatsApp Image 2025-05-10 at 22.00.33_1664941f.jpg";
import { useNavigate } from "react-router-dom";
const HealthCare = () => {
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="bg-gray-100 text-gray-800" style={{ marginTop: "80px" }}>
      <motion.header
        className="bg-blue-900 text-white py-16 text-center shadow-lg rounded-lg"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="bg-gradient-to-r from-blue-50 to-indigo-100 py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                <span className="text-white">
                  🌟 Comprehensive Healthcare Solutions Tailored for{" "}
                </span>
                <span className="text-blue-600">Your Practice</span>
              </h1>
              <p style={{ fontWeight: "bold" }} className="mt-4">
                Accurate Medical Billing Services for Healthcare Providers
              </p>
              <p className="text-white mt-4 mb-8">
                Maximize revenue and maintain compliance with our precise
                medical billing services. Our experienced specialists leverage
                advanced technology and industry best practices to ensure each
                claim is submitted accurately and promptly. We also provide
                ongoing monitoring and expert support to help healthcare
                providers enhance their revenue cycles.
              </p>
              {/* <button
                onClick={() => navigate("/bookmeeting")}
                style={{ color: "black" }}
                className="mt-4 bg-white text-blue-700 px-6 py-3 font-bold rounded-full hover:bg-blue-100 transition"
              >
                Meet Us
              </button> */}
            </div>
          </div>
        </div>
      </motion.header>

      {/* About Section */}
      <section className="py-16 bg-white" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-blue-900 text-center">
          🏥 Redefining Healthcare Support
        </h2>
        <p className="mt-4 text-lg max-w-4xl mx-auto">
          At Right On Time Services, we specialize in delivering premium Medical
          Billing, Transcription, and Management Services tailored to healthcare
          providers. Our team ensures maximum reimbursement by mastering coding
          regulations and payment submissions. We also provide:
        </p>
        <p className="mt-4 text-lg max-w-4xl mx-auto">We also provide:</p>
        <ul className="list-disc list-inside text-lg max-w-4xl mx-auto">
          <li>
            Fast and accurate transcription for efficient patient documentation.
          </li>
          <li>
            Business management services, including financial analysis and
            strategic planning, designed to improve operational efficiency.
          </li>
        </ul>
        <p
          className="mt-4 text-lg max-w-4xl mx-auto"
          style={{ fontWeight: "bold" }}
        >
          Our commitment is to provide exceptional services, empowering
          healthcare providers to focus solely on patient care.
        </p>
      </section>

      {/* Services Section */}
      <motion.section className="py-16 bg-gray-100" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-blue-900 text-center">
          🩺 Our Healthcare Services
        </h2>
        <div
          className="max-w-6xl mx-auto grid md:grid-cols-2 lg:grid-cols-2 gap-8 px-8 mt-6"
          style={{ marginTop: "30px" }}
        >
          <motion.div
            className="p-8 bg-white rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">Medical Billing</h3>
            <p className="mt-2">
              Efficient and error-free billing services designed to minimize
              billing discrepancies and maximize revenue for healthcare
              providers.
            </p>
          </motion.div>
          <motion.div
            className="p-8 bg-white rounded-lg shadow-lg hover:shadow-2xl transition duration-300"
            whileHover={{ scale: 1.05 }}
            data-aos="fade-up"
          >
            <h3 className="text-xl font-bold text-blue-900">
              Expert Medical Coding and Claim Submission
            </h3>
            <ul className="mt-2 list-disc list-inside">
              <li>Comprehensive medical coding and claim submissions</li>
              <li>Denial management and revenue cycle optimization</li>
              <li>Real-time reporting and ongoing compliance support</li>
            </ul>
          </motion.div>
        </div>
      </motion.section>

      <section id="graphic-design" className="py-20 bg-white">
        <h2
          className="text-4xl text-center font-bold mb-4 mt-4"
          style={{ padding: "30px" }}
        >
          🔧 Services We Provide
        </h2>
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center px-4 md:px-12">
          {/* Left Side - Content */}
          <div className="flex flex-col justify-center">
            <p className="text-lg text-gray-700 mb-6 max-w-xl">
              Our healthcare solutions are tailored to ensure operational
              efficiency and regulatory compliance:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-8 max-w-xl pl-5">
              <li>Medical Billing & Coding</li>
              <li>Revenue Cycle Management</li>
              <li>Accounts Receivable</li>
              <li>Denial Management</li>
              <li>Credentialing</li>
              <li>Practice Management</li>
              <li>Medical Transcription</li>
            </ul>

            <div className="mb-8">
              <h3 className="text-2xl font-semibold mb-2">
                ✍️ Accurate Medical Transcriptions
              </h3>
              <p className="text-gray-700 mb-2">
                Secure and Compliant Transcription Solutions
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 pl-5">
                <li>
                  We offer precise transcription services adhering to HIPAA
                  regulations, ensuring patient confidentiality and data
                  security.
                </li>
                <li>
                  Specialized medical transcriptionists proficient in medical
                  terminology
                </li>
                <li>
                  Cutting-edge technology for quick turnaround and accuracy
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-2xl font-semibold mb-2">
                ⚙️ Advanced Management Services
              </h3>
              <p className="text-gray-700 mb-2">
                Our healthcare management solutions streamline business
                operations while maintaining the highest industry standards. We
                support:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 pl-5">
                <li>Patient Payments Management</li>
                <li>Patient Calls Handling</li>
                <li>Insurance Eligibility Checks</li>
                <li>Appointment Confirmations</li>
                <li>Regular Reporting for Business Insights</li>
              </ul>
            </div>
          </div>

          {/* Right Side - Image */}
          <div className="flex justify-center items-center">
            <img
              src={pic1}
              alt="Healthcare Services"
              className="w-auto h-auto max-h-[600px] object-contain rounded-xl"
            />
          </div>
        </div>
      </section>

      {/* Why Choose Us? */}
      <section className="py-16 bg-gray-100" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-blue-900 text-center">
          💡 Why Choose Right On Time Services for Healthcare Solutions?
        </h2>
        <ul
          className="list-disc list-inside text-lg max-w-4xl mx-auto"
          style={{ marginTop: "30px" }}
        >
          <li>
            Experienced Professionals: Proven expertise in healthcare
            management.
          </li>
          <li>
            Customized Solutions: Tailored services that fit your business
            needs.
          </li>
          <li>
            Cutting-edge Technology:Utilization of advanced tools for efficient
            operations.
          </li>
          <li>
            HIPAA Compliance: Ensuring complete data security and patient
            confidentiality.
          </li>
          <li>
            Scalable Services: Designed to grow with your healthcare practice.
          </li>
        </ul>
      </section>

      <section
        id="start-project"
        className="py-20 bg-gray-100"
        style={{ padding: "30px" }}
      >
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-blue-900 mb-8">
            🚀 Ready to Start Your Project?
          </h2>
          <p className="text-lg max-w-3xl mx-auto mb-8">
            Let’s Build Success Together!
          </p>
          <button
            onClick={() => navigate("/bookmeeting")}
            style={{ background: "darkblue", color: "white" }}
            type="submit"
            className="px-8 py-3 rounded-md font-medium hover:bg-blue-700 transition-colors"
          >
            🔗 Book a Free Consultation
          </button>
        </div>
      </section>

      <section id="contact" className="py-20 bg-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-blue-900 mb-8">
            📩 Get in Touch
          </h2>
          <p className="text-lg max-w-3xl mx-auto mb-8">
            We're here to help. Reach out to us for more details or to get
            started!
          </p>
          <p className="text-lg">
            Email:{" "}
            <a
              href="mailto:info@rightontimeservices.com"
              className="text-blue-600"
            >
              info@rightontime.biz
            </a>
          </p>
          <p className="text-lg">
            Phone:{" "}
            <a href="tel:+92394017907" className="text-blue-600">
              03394017907
            </a>
          </p>
          <p className="text-lg">
            Address: Al-Rehman Chamber, Fazal e Haq Road, G 7/3 Blue Area,
            Islamabad, 44000 Rawalpindi.
          </p>
        </div>
      </section>

      {/* Contact & Form Section */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900">
            Get in Touch With Us
          </h2>
          <p
            className="text-lg text-gray-700 mt-4"
            style={{ marginBottom: "12px" }}
          >
            Looking for reliable BPO call center solutions? Let's work together.
          </p>
          <form className="mt-8 bg-gray-100 p-6 rounded-lg shadow-lg">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-gray-700 font-semibold">
                  Select Service:
                </label>
                <select
                  className="w-full p-3 mt-2 rounded border"
                  style={{ padding: "6px" }}
                >
                  <option>BPO</option>
                  <option>Healthcare</option>
                  <option>Digital Marketing</option>
                  <option>Software Development</option>
                  <option>Other</option>
                </select>
              </div>
              <div>
                <label className="text-gray-700 font-semibold">
                  Full Name:
                </label>
                <input
                  style={{ padding: "6px" }}
                  type="text"
                  className="w-full p-3 mt-2 rounded border"
                  placeholder="Your Name"
                />
              </div>
              <div>
                <label className="text-gray-700 font-semibold">
                  Email Address:
                </label>
                <input
                  style={{ padding: "6px" }}
                  type="email"
                  className="w-full p-3 mt-2 rounded border"
                  placeholder="Your Email"
                />
              </div>
              <div>
                <label className="text-gray-700 font-semibold">
                  Phone Number:
                </label>
                <input
                  style={{ padding: "6px" }}
                  type="text"
                  className="w-full p-3 mt-2 rounded border"
                  placeholder="+92 - - - - - -"
                />
              </div>
            </div>
            <div className="mt-4">
              <label className="text-gray-700 font-semibold">
                Project Description:
              </label>
              <textarea
                className="w-full p-3 mt-2 rounded border"
                rows="4"
              ></textarea>
            </div>
            <button
              className="w-full mt-6 bg-blue-700 py-3 font-bold rounded-full hover:bg-blue-900 transition"
              style={{ color: "white" }}
            >
              Submit Request
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default HealthCare;
